import localForage from 'localforage';

// SEE: https://localforage.github.io/localForage/

const dbStore = localForage.createInstance({
    name: 'ehi',
    storeName: 'dbStore',
    driver: [
        localForage.INDEXEDDB,
        localForage.LOCALSTORAGE,
    ]
});

export default dbStore;